var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessageSquare = function SvgMessageSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.53 1.988a2.484 2.484 0 0 1 2.482 2.483v11.294a2.483 2.483 0 0 1-2.483 2.482H7.132c-.34 0-.666.136-.906.376l-2.073 2.072a1.27 1.27 0 0 1-2.165-.896V4.47a2.483 2.483 0 0 1 2.483-2.483zm-15.06 1.2A1.284 1.284 0 0 0 3.189 4.47v15.328a.07.07 0 0 0 .042.062.07.07 0 0 0 .075-.014l2.072-2.073a2.48 2.48 0 0 1 1.755-.727h12.397a1.284 1.284 0 0 0 1.282-1.282V4.47a1.284 1.284 0 0 0-1.282-1.283z"
  })));
};
export default SvgMessageSquare;